import { useCallback } from 'react';
import { useNavigate } from 'react-router';
import { FilePreviewPopupShell } from '../mediaViewer/FilePreviewPopupShell';
import { displayNameFromPath } from '../mediaViewer/mediaFileTypes';
import { fileAccessRestrictedHref } from '../storageAccess/fileAccessRestrictedUrls';
import { PdfViewerSurface } from './PdfViewerSurface';
import '../mediaViewer/MediaPreviewPopup.css';
import '../mediaViewer/mediaViewerStage.css';
import './PdfPreviewPopup.css';

export interface PdfPreviewState {
  open: boolean;
  mountId: string;
  relativePath: string;
}

interface PdfPreviewPopupProps {
  state: PdfPreviewState | null;
  onClose: () => void;
}

export function PdfPreviewPopup({ state, onClose }: PdfPreviewPopupProps) {
  const navigate = useNavigate();
  const open = state?.open ?? false;
  const mountId = state?.mountId ?? '';
  const relativePath = state?.relativePath ?? '';
  const fileName = displayNameFromPath(relativePath);
  const title = relativePath ? `PDF: ${fileName}` : 'PDF preview';

  const onRestrictedAccess = useCallback(() => {
    onClose();
    navigate(fileAccessRestrictedHref(), { replace: true });
  }, [navigate, onClose]);

  return (
    <FilePreviewPopupShell visible={open} title={title} onClose={onClose}>
      <div className="pdf-preview-popup__body">
        <PdfViewerSurface
          mountId={mountId}
          path={relativePath}
          enabled={open}
          onRestrictedAccess={onRestrictedAccess}
          className="pdf-preview-popup__surface"
        />
      </div>
    </FilePreviewPopupShell>
  );
}
